module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Lavey-Morcles_(Vaud)-f33e9487325bce14ca6c4a04ea928928.svg";